import throttle from '@/throttle'

document.addEventListener('DOMContentLoaded', () => {
  const toTopButton = document.querySelector('.js-scroll-to-top-button')

  // ボタンクリックでページトップまでスクロールバック
  toTopButton.addEventListener('click', event => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const target = event.target as HTMLElement
    target.blur()
  })

  // Viewport の高さ分スクロールしたら、ボタンを見えなくするためのクラスを削除
  // Viewport の高さ分スクロールできない高さの場合、ボタンを吹き飛ばすためのクラスを付与
  {
    let threshold: number
    const setThreshold = throttle(() => {
      threshold = window.innerHeight
    }, 17) // ≒ 60fps
    setThreshold()

    const controlClassInvisible = throttle(() => {
      threshold < (window.scrollY || window.pageYOffset)
        ? toTopButton.classList.remove('js-invisible')
        : toTopButton.classList.add('js-invisible')
    }, 17) // ≒ 60fps
    controlClassInvisible()

    const controlClassHidden = throttle(() => {
      document.body.clientHeight < threshold * 2
        ? toTopButton.classList.add('js-hidden')
        : toTopButton.classList.remove('js-hidden')
    }, 17) // ≒ 60fps
    controlClassHidden()

    window.addEventListener('scroll', controlClassInvisible)
    window.addEventListener('resize', setThreshold)
    window.addEventListener('resize', controlClassHidden)
    window.addEventListener('resize', controlClassInvisible)
  }

  // 親要素が見えたらボタン位置を親要素からの absolute にするクラスを付与
  {
    const controlClass = (entries: IntersectionObserverEntry[]) => {
      entries[0].intersectionRatio > 0
        ? toTopButton.classList.add('js-desktop-stick-parent')
        : toTopButton.classList.remove('js-desktop-stick-parent')
    }
    const observer = new IntersectionObserver(controlClass, { threshold: 0 })

    observer.observe(toTopButton.parentElement)
  }
})
